import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{!-- Pattern borrowed from ember-cli-head --}}\n{{#in-element this.head insertBefore=null}}\n  {{!-- template-lint-disable no-forbidden-elements --}}\n  <meta name=\"robots\" content=\"noindex\" />\n{{/in-element}}", {
  moduleName: "vagrant/components/no-index/index.hbs"
});